/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { createSelector } from '@reduxjs/toolkit';
import { initialState } from './slice';
//
const selectDomain = (state) => state['feature/scenario'] || initialState;
/**
 * Getting loader state to scenario component
 */
export const selectLoader = createSelector(
  [selectDomain],
  (scenarioState) => scenarioState.loading
);
/**
 * Getting scenarios state to scenario component
 */
export const selectScenarios = createSelector(
  [selectDomain],
  (scenarioState) => scenarioState.scenarios
);
/**
 * Getting the scenario details by scenario id state into scenario component
 */
export const selectScenarioByID = createSelector(
  [selectDomain],
  (scenarioState) => scenarioState.scenarioById
);
/**
 * Getting is session timed out state for the component
 */
export const selectIsSessionTimedOut = createSelector(
  [selectDomain],
  (scenarioState) => scenarioState.isSessionTimedOut
);
/**
 * Getting visual filters state to dashboard component
 */
export const selectVisualFilters = createSelector(
  [selectDomain],
  (state) => state.visualFilters?.results
);
/**
 * Getting dynamic breakdown state for dashboard component
 */
export const selectBreakdownDetails = createSelector([selectDomain], (state) => state.breakdown);
/**
 *  Getting all hotel list state to transaction component
 */
export const selectAllHotelList = createSelector([selectDomain], (state) => state.allHotelList);
/**
 * Getting visuals state to visual component
 */
export const selectVisuals = createSelector([selectDomain], (state) => state.visuals);
